//--general
import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import {sliderHome} from './parts/sliders.js';
import {sliderPhone} from './parts/sliders.js';
import {aboutSlider1} from './parts/sliders.js';
import {aboutSlider2} from './parts/sliders.js';
import {continuousSlider} from './parts/sliders.js';
import {smoothAnchor} from './parts/smooth_anchor';
import {accordionFooter} from './parts/accordion';

(function ($) {

    var windowW = $(window).width()

    //-- delay function for resizing
    var delay = (function() {
        var timer = 0;
        return function(callback, ms) {
            clearTimeout(timer);
            timer = setTimeout(callback, ms);
        }
    })();


    function setHeadHeight() {
        var garphicH = $('.head .bg-box').height()

        if ( windowW > 991) {   
            $('.head').css({'min-height': garphicH});
        } else {
            $('.head').css({'min-height': 'auto', 'padding-top': garphicH});
        }
    }

    function setLineHeight() {
        var headH = $('.head .bg-box').height();
    }


    //set height blue line in items boxes
    function setHeightLine() {
        var imageHeight = $('.bg-box__img').height(),
            headH = $('.head').outerHeight(),
            lineHeight = headH - imageHeight/2 - (headH*0.05);

        $('#line-desktop').css('height', lineHeight)
    }

    $(document).ready(function(){

        sliderHome();
        sliderPhone();
        aboutSlider1();
        aboutSlider2();
        smoothAnchor();
        continuousSlider();
        accordionFooter();

        setTimeout(function(){
            setHeightLine();
            setHeadHeight();
            setLineHeight();
        },100)

        //mobile nav

        $("#menu-mobile-btn").click(function(){
            $('#main-nav').addClass('show');

            if (windowW < 992) {

                setTimeout(function(){
                    $('#main-nav').addClass('active');
                }, 700)

                //animate items
                $('#main-nav li').each(function(i){
                    var that = $(this);
                    setTimeout(function(){
                        that.addClass('visible')
                    }, 200 + i*100)
                })
            }
        })

        $('#menu-mobile-close').click(function(){
            $('#main-nav').removeClass('show active');

            //remove animate class items
            $('#main-nav li').each(function(i){
                $(this).removeClass('visible')
            })
        })

    });

    $(window).on({
        load:function(){

            setHeightLine();
            setHeadHeight();
            setLineHeight();

        $('body').addClass('loaded')

        },
        resize:function(){

            setHeightLine();
            setHeadHeight();
            setLineHeight();

        },
        scroll:function(){

       }
    });

    AOS.init({
        // Global settings:
        disable: 'mobile', // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
        startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
        initClassName: 'aos-init', // class applied after initialization
        animatedClassName: 'aos-animate', // class applied on animation
        useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
        disableMutationObserver: false, // disables automatic mutations' detections (advanced)
        debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
        throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
        
      
        // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
        offset: 0, // offset (in px) from the original trigger point
        delay: 500, // values from 0 to 3000, with step 50ms
        duration: 1500, // values from 0 to 3000, with step 50ms
        easing: 'ease', // default easing for AOS animations
        once: false, // whether animation should happen only once - while scrolling down
        mirror: false, // whether elements should animate out while scrolling past them
        anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
      
      });

}(jQuery));